module.exports = __webpack_public_path__ + "img/category_education.3bc72c9.png";